var map = {
	"./Alarm.png": 87602,
	"./Announcement.png": 65924,
	"./Application.png": 3599,
	"./Archive.png": 72839,
	"./ArrowNorth.png": 73253,
	"./Badge.png": 58388,
	"./Bank.png": 31427,
	"./Barcode.png": 10673,
	"./Bin.png": 6994,
	"./BlackBox.png": 70161,
	"./BlockWithSun.png": 17578,
	"./Blocks.png": 46763,
	"./BlueCabinet.png": 2153,
	"./BlueCube.png": 76146,
	"./BottleChemistry.png": 4055,
	"./Box.png": 49746,
	"./BoxWithLabel.png": 18930,
	"./BoxWithStar.png": 79678,
	"./Briefcase.png": 51085,
	"./Briefcase2.png": 62315,
	"./BriefcaseWithQuestion.png": 54017,
	"./CabinetWithCalendar.png": 84495,
	"./Calculator.png": 17841,
	"./CalculatorWithFolder.png": 77069,
	"./Calendar.png": 20515,
	"./CalendarWithClock.png": 39713,
	"./CalendarWithClock2.png": 67879,
	"./CalendarWithClock3.png": 80190,
	"./Chart.png": 51373,
	"./Check.png": 96921,
	"./Checkbook.png": 27786,
	"./Checks.png": 33702,
	"./ChronologicalReview.png": 47755,
	"./CircleWithArrow.png": 58398,
	"./CircleWithDollarSign.png": 83680,
	"./CircleWithDollarSign2.png": 66160,
	"./CircleWithTick.png": 23574,
	"./CircleWithTick2.png": 97238,
	"./ClockWithCalendar.png": 83889,
	"./Comment.png": 4466,
	"./Community.png": 45482,
	"./Companies.png": 69424,
	"./CompanyLogs.png": 22425,
	"./Computer.png": 28146,
	"./Cone.png": 95180,
	"./Configuration.png": 71487,
	"./Contacts.png": 41230,
	"./CreditCardBlue.png": 56884,
	"./CreditCards.png": 86437,
	"./CubeBlue.png": 21134,
	"./Document.png": 35986,
	"./DocumentWithClock.png": 86662,
	"./DocumentWithList.png": 50114,
	"./DocumentWithPencil.png": 21221,
	"./Documents.png": 16163,
	"./Drill.png": 47838,
	"./DropBox.png": 51031,
	"./EMail.png": 99397,
	"./EarthWithPurpleArrow.png": 40364,
	"./EmailNew.png": 58759,
	"./Envelope.png": 69209,
	"./Expense.png": 82449,
	"./Field.png": 94797,
	"./File.png": 42339,
	"./FileCabinet.png": 81832,
	"./FileWithTextAndFont.png": 11396,
	"./Flag.png": 82539,
	"./Folder.png": 64945,
	"./FolderUser.png": 30968,
	"./FolderWithEye.png": 56162,
	"./FolderWithFolders.png": 8162,
	"./FolderWithHammer.png": 22500,
	"./FolderWithLabel.png": 46155,
	"./FolderWithMagnifier.png": 57193,
	"./FolderWithStar.png": 50221,
	"./FolderWithUser.png": 73652,
	"./Gavel.png": 10360,
	"./GavelVendors.png": 65127,
	"./Gear.png": 77128,
	"./GraphMoney.png": 45833,
	"./GreenCabinet.png": 74582,
	"./GreenCube.png": 90975,
	"./GroupOfPeople.png": 10798,
	"./GroupOfPeople3.png": 88263,
	"./GroupOfPeopleWithQuestion.png": 58298,
	"./GroupOfPeopleWithQuestion2.png": 90322,
	"./Help.png": 99552,
	"./House.png": 87977,
	"./Inbox.png": 72849,
	"./Info.png": 96481,
	"./Invoice.png": 31756,
	"./InvoiceBuilder.png": 10627,
	"./InvoiceSchedular.png": 28225,
	"./Keyboard.png": 2778,
	"./Keyboard_Database.png": 34784,
	"./Keyboard_Journal.png": 89330,
	"./Keyboard_Vendor.png": 28165,
	"./Keyboard_Vendors.png": 92202,
	"./Language.png": 44943,
	"./Lightning.png": 86159,
	"./List.png": 55637,
	"./Lock.png": 36280,
	"./LoudSpeaker.png": 71682,
	"./Mail.png": 46956,
	"./MailInbox.png": 14786,
	"./Map.png": 94843,
	"./MoneyWithScissors.png": 98680,
	"./Notepad.png": 55282,
	"./OpenBox.png": 34106,
	"./OpenHand.png": 13506,
	"./Order.png": 37057,
	"./PDF.png": 47823,
	"./PO.png": 34958,
	"./Package.png": 51777,
	"./PalletizedBoxes.png": 68254,
	"./PaperWithPen.png": 11770,
	"./Papers.png": 67552,
	"./Payroll_Keyboard.png": 1472,
	"./Pen.png": 16416,
	"./PercentSign.png": 18485,
	"./PersonWithSuit.png": 78413,
	"./PieChart.png": 93871,
	"./Power.png": 91190,
	"./Present.png": 35976,
	"./PrintQue.png": 48321,
	"./Printer.png": 93165,
	"./Property.png": 39162,
	"./Question.png": 90113,
	"./ReCurring.png": 93232,
	"./Receipt.png": 82097,
	"./Receiving.png": 78367,
	"./RedCabinet.png": 79954,
	"./RedCreditCard.png": 83421,
	"./Refresh.png": 30724,
	"./Register.png": 39630,
	"./RegisterWithUser.png": 78495,
	"./ReleasePayments.png": 82907,
	"./SO.png": 16835,
	"./Safe.png": 35922,
	"./SafetyBox.png": 83180,
	"./SaleBlack.png": 38815,
	"./SaleBlue.png": 54604,
	"./SaleGreen.png": 72351,
	"./SaleRed.png": 49599,
	"./SaleYellow.png": 36376,
	"./Scanner.png": 41815,
	"./ScannerWithCamera.png": 60578,
	"./Schedular.png": 36926,
	"./Share.png": 47940,
	"./Sharemanager.png": 74183,
	"./Shield.png": 80818,
	"./Signature.png": 34391,
	"./Sledgehammer.png": 82865,
	"./Speedometer.png": 38394,
	"./Spiral.png": 40302,
	"./Spreadsheet.png": 37531,
	"./Star.png": 37169,
	"./Stopwatch.png": 69596,
	"./Summary.png": 46245,
	"./SyncAccountsPayable.png": 95160,
	"./SyncCustomers.png": 80153,
	"./SyncEmployees.png": 69497,
	"./SyncIncomeExpense.png": 1761,
	"./SyncVendors.png": 78723,
	"./Synchronize.png": 5815,
	"./TaskList.png": 40698,
	"./Taxes.png": 50534,
	"./Template.png": 59747,
	"./Templates.png": 7152,
	"./ThreeBlocks.png": 29195,
	"./ThreeUserx.png": 16874,
	"./UploadAccountsPayable.png": 35506,
	"./UploadFilingCabinet.png": 51089,
	"./User.png": 73152,
	"./UserWithPencil.png": 56447,
	"./UsersWithLock.png": 48660,
	"./Vendors[2].png": 59502,
	"./Visitor.png": 16959,
	"./Volume.png": 50531,
	"./Wallet.png": 59822,
	"./Wallet2.png": 82910,
	"./Warning.png": 2245,
	"./Window.png": 15557,
	"./WindowWithMagnifier.png": 63629,
	"./WindowWithText.png": 6492,
	"./WireTransfer.png": 21219,
	"./World.png": 74805,
	"./Wrench.png": 8126,
	"./WrenchAndFlatHead.png": 53860,
	"./WrenchWithScrewdriver.png": 98502,
	"./billb.png": 79550,
	"./calculator2.png": 68311,
	"./folderwithperson.png": 43534,
	"./threeuser.png": 32256,
	"./transparrentinvoice.png": 33533,
	"./usersinring.png": 48438,
	"./vcalendar.png": 96265,
	"./vendors.png": 95468,
	"./vendors[old].png": 55625
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90986;